import React from "react";
import { Card, Button, Modal, List as AntList, Col ,Icon } from "antd";
import PropTypes from "prop-types";
import cx from "classnames";
import { Map, List } from "immutable";
import { LoaderSkeleton, Table } from "../../components";
import {ENTITY_VERIFICATION_COLS} from "../../constants/table-columns";
import {RCU_VERIFICATION_STATUS_TYPES} from "../../constants/enums";
import { DocumentViewer } from "components/index";
import "styles/applicant-verification.css";

const ListItem = AntList.Item;
class EntityVerificationTable extends React.Component{
    
    tableColumns = ENTITY_VERIFICATION_COLS;

    state = {
        selectedDocType: null,
        openDocSelectionModal: false,
        selectedDoc: null,
        selectedRequest: null,
        selectedFileId: null,
        showDoc: false
    };

    isLoading = () => false;

    verifyDetails = (type, data ) => {
        let details = {
            document : data.document,
            name: data.entity_name,
            id: data.request_id,
            aadhar_no: data.aadhar_no,
            phone_no: data.phone_no,
            pan_no: data.pan_no,
            email_id: data.email_id,
            company_pan: {
                request_id: data.request_id || "",
                verification_source: data.verification_source || "",
                verification_status: data.verification_status  || ""
            }
        };
        this.props.verifyDetails(type, details );
    }

    updateSelectedDocument = (file) => {
        this.setState({
            selectedDoc: file
        }, () => {
            this.toggleDocumentSelectionModal(null);
        });
    }

    toggleDocumentSelectionModal = (document) => {
        this.setState({
            selectedDocType: document,
            openDocSelectionModal: !this.state.openDocSelectionModal
        });
    }

    showDocument = (id, doc) => {
        this.setState({
            showDoc: true,
            fileUrl: doc.file
        });
    }

    openDocumentViewer = () => {
        return (
            <Modal
                visible={this.state.showDoc}
                onCancel={() => {
                    this.setState({
                        showDoc: false
                    });
                }}
                onOk={() => {}}
                title={"File View"}
                width={"fit-content"}
            >
                <DocumentViewer
                    url={this.state.fileUrl}
                    width={600}
                    height={800}
                />
            </Modal>
        );
    }

    getTitle = (doc) => {
        return (
            <Col
                span={24}
                className={
                    "d-flex flex-direction-row justify-content-space-between"
                }
            >
                <div
                    style={{
                        textOverflow: "ellipsis",
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#000000"
                    }}
                >
                    {doc.document && doc.document.document_name}
                </div>
                <div style={{
                    color: "#eb5757",
                    background: "transparent",
                    cursor: "pointer",
                    fontSize: 12
                }}>
                    <Button type={"link"} icon={"eye"} onClick={() => this.showDocument(doc.id, doc)}>
                        View
                    </Button>
                </div>
            </Col>
        );
    }

    selectFile = file => this.setState({
        selectedFileId: file.id
    });
    isSelected = file => file && file.id === this.state.selectedFileId;

    showDocumentSelectionModal = () => {
        let documents = this.props.documents.filter(_ => _.file !== null);
        if(this.state.selectedDocType == "aadhar") {
            documents = documents.filter(_ => [8, 13].includes(_.document && _.document.id));
        } else if(this.state.selectedDocType == "pan") {
            documents = documents.filter(_ => [7, 12].includes(_.document && _.document.id));
        }
        return (
            <Modal
                visible={this.state.openDocSelectionModal}
                closable={true}
                className={"document-search"}
                title={`Select Appropriate ${this.state.selectedDocType == "aadhar" ? "Aadhar" : "Pan"}`}
                destroyOnClose
                onCancel={this.toggleDocumentSelectionModal}
                onOk={this.updateSelectedDocument}
            >
                <div className="p-10">
                    {
                        documents && documents.size ?
                            (
                                <AntList
                                    grid={{column: 1}}
                                >
                                    {documents.map(_ => (
                                        <ListItem
                                            className={cx("item-unclicked", {
                                                ["clicked-item"]: this.isSelected(_)
                                            })}
                                            key={_.id}
                                        >
                                            <Card
                                                title={this.getTitle(_)}
                                                onClick={this.selectFile.bind(null, _)}
                                                className={
                                                    "padless-card no-shadow w-100 document-list"
                                                }
                                            />
                                        </ListItem>
                                    )).toList().toArray()}
                                </AntList>
                            )
                            : null
                    }
                </div>
            </Modal>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.showDocumentSelectionModal()}
                {this.openDocumentViewer()}
                <LoaderSkeleton loading={this.isLoading()}>
                    <Card
                        className={"padless-card m-10"}
                        title={"Entity Details Verification"}
                    >
                        <Table
                            columns={this.tableColumns}
                            data={(this.props.associates || new List([])).map(_ => {
                                var row = _.company_pan;
                                if( _.company_pan  && _.company_pan.verification_status === RCU_VERIFICATION_STATUS_TYPES.UNINITIATED ) {
                                    row.is_company_pan_verified = (
                                        <Button
                                            onClick={this.verifyDetails.bind(null, "company_pan", _.company_pan)}
                                            type={"link"}
                                        >
                                            {"Verify"}
                                        </Button>
                                    );
                                }
                                if( _.company_pan  && _.company_pan.verification_status === RCU_VERIFICATION_STATUS_TYPES.VERIFIED ) {
                                    row.is_company_pan_verified = (
                                        <span>Verified</span>
                                    );
                                }
                                if( _.company_pan  && _.company_pan.document === null ) {
                                    row.is_company_pan_verified = (
                                        <span>Document Not Available</span>
                                    );
                                }
                                if( _.company_pan  && _.company_pan.verification_status === RCU_VERIFICATION_STATUS_TYPES.FAILED ) {
                                    row.is_company_pan_verified = (
                                        <>
                                        <span>Failed</span>
                                        <Button 
                                            style={{
                                                border : 0,
                                                background : "transparent"
                                            }}
                                            onClick={() => this.props.fetchAssociateList(_.company_pan.request_id)}
                                        >
                                            <Icon type="redo" />
                                        </Button>
                                        <span>{_.company_pan && 
                                        _.company_pan.verification_response &&
                                        _.company_pan.verification_response.data&& 
                                         _.company_pan.verification_response.data.upstreamName}</span>
                                        </>
                                    );
                                }
                                return row;
                            })}
                            loading={this.props.loading}
                            showFilters={false}
                            showTopSection={false}
                            size={"small"}
                            showColumnSelector={false}
                            checkedColumns={[]}
                        >
                        </Table>
                    </Card>
                </LoaderSkeleton>
            </React.Fragment>
        );
    }
}

EntityVerificationTable.propTypes = {
    associates: PropTypes.object,
    verifyDetails: PropTypes.func,
    loading: PropTypes.bool,
    downloadRcuReport: PropTypes.func,
    reloadData: PropTypes.func,
    documents: PropTypes.array,
    fetchAssociateList :PropTypes.func
};

EntityVerificationTable.defaultProps = {
    associates: new Map({})
};

export default (EntityVerificationTable);